module.exports = __webpack_public_path__ + "media/images/front/icons/new-68f268f5ad43cd2838501b244d8b016c.png";